import { render, staticRenderFns } from "./TaskKanban.vue?vue&type=template&id=66ba38cd&scoped=true"
import script from "./TaskKanban.vue?vue&type=script&lang=js"
export * from "./TaskKanban.vue?vue&type=script&lang=js"
import style0 from "./TaskKanban.vue?vue&type=style&index=0&id=66ba38cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba38cd",
  null
  
)

export default component.exports